import { renderToString } from 'react-dom/server';
import I18n from 'I18n';
import { getPropertyLabel, getReferenceLabel } from 'reporting-data/v2/dataset/datasetTypes';
import { CustomHighchartsTooltip, TooltipHeader, TooltipBody, TooltipBodyListContainer, TooltipBodyLabel, TooltipBodyValue } from '../../../highcharts/options/customTooltipStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderTooltipBodyList = propertyList => Object.keys(propertyList).map(property => {
  const label = I18n.text('reporting-visualizations.tooltip.group', {
    group: property
  });
  const value = propertyList[property];
  return /*#__PURE__*/_jsxs(TooltipBodyListContainer, {
    children: [/*#__PURE__*/_jsx(TooltipBodyLabel, {
      children: label
    }), /*#__PURE__*/_jsx(TooltipBodyValue, {
      children: value
    })]
  }, property);
});
const renderTooltip = ({
  header,
  propertyList,
  additonalInfo
}) => /*#__PURE__*/_jsxs(CustomHighchartsTooltip, {
  children: [/*#__PURE__*/_jsx(TooltipHeader, {
    children: header
  }), /*#__PURE__*/_jsxs(TooltipBody, {
    children: [renderTooltipBodyList(propertyList), additonalInfo]
  })]
});
export const getTooltipFormatter = (dataset, layout, linksDataMap, nodeLabels, dropoffByNode) => function () {
  let tooltip = null;
  const {
    id,
    options: {
      isNode,
      name,
      from,
      to
    }
  } = this.point;
  const {
    measures: {
      renderCustomTooltipInfo
    }
  } = layout;
  const additonalInfo = renderCustomTooltipInfo ? renderCustomTooltipInfo({
    point: this.point,
    dataset,
    linksDataMap
  }) : undefined;

  // map to each row to show all properties
  const measureLabel = getPropertyLabel(dataset, layout.measures.linkMeasure);
  const nodeMeasureValue = getReferenceLabel(dataset, layout.measures.destinationNodeTotal, name);

  //Below code is customized to meet CJA requirements,
  //it works on the assumption that primary field will
  //always include * if additionalInfo exist on the SankeyLayout
  //TODO: Remove the assumption and handle customization outside this component.
  const measureLableWithInfo = additonalInfo ? `${measureLabel}*` : measureLabel;
  if (isNode) {
    tooltip = renderTooltip({
      header: nodeLabels[id],
      propertyList: {
        [measureLableWithInfo]: nodeMeasureValue
      },
      additonalInfo
    });
  } else {
    // map to each row to show all properties
    const dataRecord = linksDataMap[from][to];

    //Don't tooltip invisible links
    if (dataRecord[layout.measures.linkMeasure] === 0) {
      return '';
    }
    const tooltipInformation = layout.measures.linkTooltipMeasures ? layout.measures.linkTooltipMeasures.reduce((acc, field) => Object.assign({}, acc, {
      [getPropertyLabel(dataset, field)]: getReferenceLabel(dataset, field, dataRecord[field])
    }), {}) : {};
    const linkMeasureValue = getReferenceLabel(dataset, layout.measures.linkMeasure, dataRecord[layout.measures.linkMeasure]);
    tooltip = renderTooltip({
      header: !dropoffByNode[to] ? I18n.text('reporting-visualizations.sankey.drilldown-name', {
        from: I18n.SafeString(nodeLabels[from]),
        to: I18n.SafeString(nodeLabels[to])
      }) : nodeLabels[to],
      propertyList: Object.assign({
        [measureLableWithInfo]: linkMeasureValue
      }, tooltipInformation),
      additonalInfo
    });
  }
  return renderToString(tooltip);
};